/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@mui/material";
import { useQuery } from "@apollo/client";

import moment from "moment";
import { WaitlistUpdateRequestStatus as Status, RequestedCounts, RequestedCountsVariables, WaitlistUpdateRequestStatus } from "types/gql-types";
import { ContentProps } from "../types";
import { REQUESTED_COUNTS } from "../query";
import { isBeforeDeadline } from "../utils";
import ManualContact from "./manual-contact";
import { ContentCollapsed } from "./content-collapsed";
import { ContentSection } from "./content-section";
import ProcessRemovals from "./process-removals";

const Content: React.FC<ContentProps> = (props) => {
  const [selectedStatus, setStatus] = React.useState<Status | null>(null);

  const {
    interestList,
    interestList: {
      id: listId,
      scheduledUpdate: {
        ends,
      },
    },
  } = props;

  const countResults = useQuery<RequestedCounts, RequestedCountsVariables>(
    REQUESTED_COUNTS,
    { variables: {
      id: listId,
      statuses: Object.values(WaitlistUpdateRequestStatus),
    } },
  );

  const deadline = moment.utc(ends);

  const showProcessRemovals = !isBeforeDeadline(deadline);

  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 4 }}>
        <h3>Contact waitlist applicants manually</h3>
        <ManualContact interestList={interestList} countResults={countResults} />
        {showProcessRemovals && <ProcessRemovals interestListId={interestList.id} />}
      </Grid>
      <Grid size={{ md: 8 }}>
        <h3>Results</h3>
        <br/>
        {selectedStatus === null &&
            <ContentCollapsed
              setStatus={setStatus}
              countResults={countResults} />}
        {selectedStatus &&
          <ContentSection
            selectedStatus={selectedStatus}
            setStatus={setStatus}
            interestList={interestList} />}
      </Grid>
    </Grid>
  );
};

export default Content;
